import React from "react";
import { Icon } from "rhombus-react";
import { EmptyDash } from './EmptyDash';

/**
 * BasicCheck Cells
 */
export default function BasicCheck(props){
	let val = props.value;

	if(!val || val === null || val.length === 0){
		return <EmptyDash />;
	}

	return <Icon name="checkMark" iconStyle="fal" className="center-icon basic-check" />;
}

BasicCheck.defaultProps = {
	value:null,
};
